const styles = {
  global: {
    body: {
      bg: "blueGray.50",
    },
  },
};

export default styles;
